import { render, staticRenderFns } from "./MAM_TerminalAdjustAdd.vue?vue&type=template&id=04e7d38c&"
import script from "./MAM_TerminalAdjustAdd.vue?vue&type=script&lang=js&"
export * from "./MAM_TerminalAdjustAdd.vue?vue&type=script&lang=js&"
import style0 from "./MAM_TerminalAdjustAdd.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports